import { createActions, } from 'redux-actions';

export default createActions({
  CARDS: {
    SET: null,
    RESET: null,
  },
});
